module.exports = __webpack_public_path__ + "static/media/mehtab.0d9462ab.jpg";